/* eslint-disable */
import http from "@/utils/http";

// 获取 业务游戏数据
export const getGameList: (params: object) => Promise<any> = (params) => {
	return http({
		url: '/api/v1/ai2sql/get_game_list',
		method: 'post',
		errorHandler: true,
		data: params,
	});
};

// 获取 业务游戏对应的全部数据表信息
export const getTablesOfGame: (params: object) => Promise<any> = (params) => {
	return http({
		url: '/api/v1/ai2sql/get_game_all_tables',
		method: 'post',
		errorHandler: true,
		data: params,
	});
};


// 获取 数据表的字段信息
export const getTableDetail: (params: object) => Promise<any> = (params) => {
	return http({
		url: '/api/v1/ai2sql/get_table_detail',
		method: 'post',
		errorHandler: true,
		data: params,
	});
};


// 聊天对话接口
export const getChatResult: (params: object, cancelToken?: any) => Promise<any> = (params, cancelToken) => {
	return http({
		url: '/api/v1/ai2sql/conversation',
		method: 'post',
		errorHandler: true,
		data: params,
		timeout: 120000,
		cancelToken,
	});
};


// 点赞点踩
export const updateSqlLike: (params: object) => Promise<any> = (params) => {
	return http({
		url: '/api/v1/ai2sql/score',
		method: 'post',
		errorHandler: true,
		data: params,
	});
};

// 检查SQL语法
export const checkSql: (params: object) => Promise<any> = (params) => {
	return http({
		url: '/api/v1/ai2sql/check_sql',
		method: 'post',
		errorHandler: true,
		data: params,
	});
};

